import {
  IAdministrationCreate,
  IAdministrationUpdate,
} from '@tsin-core/models/administration-management';

const ACTION_SCOPE = '[Administrations]';

export class CreateAdministration {
  static readonly type = `${ACTION_SCOPE} Create Administration`;
  //   constructor(public payload: any) {}
  constructor(public payload: IAdministrationCreate) {}
}

export class GetAdministrations {
  static readonly type = `${ACTION_SCOPE} Get Administrations`;
}

export class UpdateAdministration {
  static readonly type = `${ACTION_SCOPE} Update Administration`;
  constructor(public updatePayload: IAdministrationUpdate) {}
}

export class DeleteAdministration {
  static readonly type = `${ACTION_SCOPE} Delete Administration`;
  constructor(public id: string) {}
}

export class SetLoading {
  static readonly type = `${ACTION_SCOPE} Set Loading`;
  constructor(public loading: boolean) {}
}

export class SetError {
  static readonly type = `${ACTION_SCOPE} Set Error`;
  constructor(public error: string | null) {}
}
